import {
	GET_WORKCENTER_LOCATION_COLABORATORS,
	GET_WORKCENTER_LOCATION_COLABORATORS_ERROR,
	GET_WORKCENTER_LOCATION_COLABORATORS_SUCCESS,
} from '../../../constants';

export const getWorkCenterLocationByCollaboratorReducer = (state, actions) => {
	switch (actions.type) {
		case GET_WORKCENTER_LOCATION_COLABORATORS:
			return {
				...state,
				loading: true,
				error: null,
				errorShow: false,
				workCenters: null
			};
		case GET_WORKCENTER_LOCATION_COLABORATORS_ERROR:
			return {
				...state,
				loading: false,
				error: actions.payload,
				errorShow: true,
			};
		case GET_WORKCENTER_LOCATION_COLABORATORS_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				errorShow: false,
				workCenters: actions.payload,
			};
		default:
			return state;
	}
};
